import { isProgramLead } from "@/components/helpers/workspace/permissions";
import { ProgramComponentDateView } from "@/components/pages_logged_in/program/components/program-component/ProgramComponentDateView";
import { ProgramComponentStatus } from "@/components/pages_logged_in/program/components/program-component/ProgramComponentStatus";
import { POINT_IN_TIME_COMPONENTS } from "@/components/pages_logged_in/program/components/program-timeline/utils";
import { ViewComponentButton } from "@/components/pages_logged_in/program/components/ViewComponentButton";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ComponentTypeEnum } from "@/graphql";
import {
  ChildComponent,
  LeadComponent,
  ParticipantComponent,
} from "@/types/programs";

interface ComponentCardProps {
  programId: string;
  component:
    | LeadComponent
    | ParticipantComponent
    | (ChildComponent & { targetDueDate?: string });
}

export function ComponentCard({ programId, component }: ComponentCardProps) {
  const { name, targetStartDate, targetDueDate, targetEndDate, closedAt } =
    component || {};
  const isPointInTime = POINT_IN_TIME_COMPONENTS.includes(component.type);

  return (
    <Card className="w-96 border-none">
      <CardHeader>
        <ProgramComponentStatus component={component} />
        <CardTitle>{name}</CardTitle>
      </CardHeader>

      <CardContent>
        <ProgramComponentDateView
          targetStartDate={targetStartDate}
          targetDueDate={targetDueDate}
          targetEndDate={targetEndDate}
          closedAt={closedAt}
          isPointInTime={isPointInTime}
          showDuration={component?.type === ComponentTypeEnum.GroupMeeting}
        />

        <div className="mt-4">
          <ViewComponentButton
            programId={programId}
            component={component}
            intent="secondary"
            fill={true}
            isProgramLead={isProgramLead(programId)}
          />
        </div>
      </CardContent>
    </Card>
  );
}
